/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmuaEntityDetails } from './vmuaEntityDetails';


/**
 * Response containing a list of registered entities and their associated keys. Can be filtered by optional entityId query parameter.
 */
export interface VmuaEntitiesListResponse { 
    /**
     * Array of registered entity details with their key information.
     */
    entities?: Array<VmuaEntityDetails>;
    /**
     * Total number of entities returned in this response. Pass 0 to immediately set the key to EXPIRED with no grace period.
     */
    count?: number;
}

